import React from 'react'

import { COMPLIANCE_INBOX } from '@/reducers/tasks/tasks.constants'
import { InboxRedirect } from '@/components/inbox/InboxRedirect'

export const ComplianceInbox = () => {
  return <InboxRedirect inboxType={COMPLIANCE_INBOX} title="Balto Compliance" />
}
